import React, { useState, useCallback } from 'react'
import Addons from './Addons'
import Modal from '../common/Modal';
import { useTransition, animated } from 'react-spring';
import { addToCart as cartAddToCart, minusToCart, popPopToggle } from '../redux/actions/cart';
import { connect } from 'react-redux';
import { isAdded, isAddedSelector } from '../redux/reducers/cart';
import { formatPrice, getImage, isDigitalMenu, merchantId } from '../common/Functions';
import { getSpecialCats, getItemCategory } from '../redux/reducers/restaurant';
import {Lightbox} from "react-modal-image";

const appRoot = document.getElementById('root');


function Item({ item, splcats, getItemCategoryItem, isSplCat, cartCount, cartAddToCart, minusToCart, popPopToggle,merchant_id }) {
    //console.log("render");
    if (item.item_id == "5306108") {
        console.log("render", item, item.splcats);
    }
    console.log("render", item, item.splcats);
    const [addtoCart, setaddtoCart] = useState(false);
    const addToCartClickHandler = () => {
        if (item.addon_item_exists) {
            setaddtoCart(true);
            popPopToggle(true);
            return;
        }

        cartAddToCart(item, 0, [], 1, +item.prices[0].price);
    }

    const handleClose = useCallback(() => {
        setaddtoCart(false);
        popPopToggle(false);
    }, [item])

    const minusClickHandler = () => {
        if (item.addon_item_exists && cartCount > 1) {
            alert('Please remove this item from cart');
            return;
        }
        minusToCart(item);
    }
    const hasDiscount = item.discount > 0 ? true : false;

    const [popup, setPopup] = useState(false);

    const onCloseModal = () => {
        setPopup(false); 
        document.getElementById('top-header').classList.add('fixed');      
    }

    const onClickModal = () => {
        setPopup(true);
        document.getElementById('top-header').classList.remove('fixed');       
    }

    return (
        <div className={item.photo ? "with-picture food-item" : "food-item"}>
            <div className={item.dish_new[0] == 2 ? "food-type non-veg " : "food-type " + (item.dish_new[0] == 1 ? "veg" : "") + (item.dish_new[0] == 24 ? "egg" : "")}></div>
            {item.photo && ![1451,1405,1664,1667,1671,1672,2490].includes(merchant_id) && <div className="food-img">
                <img src={item.photo} alt={item.item_name} />
            </div>}
            {item.photo && [1451,1405,1664,1667,1671,1672,2490].includes(merchant_id) && <div>
            <img src={item.photo} alt={item.item_name}  onClick={onClickModal} />
                {popup && <Lightbox
                    small={item.photo}
                    large={item.photo}
                    alt={item.item_name}
                    onClose={onCloseModal}
                    hideDownload={true}
                />}
            </div>}
            <div className="food-details">
                <div className="food-detail-left">
                    <h3 className="food-name">{item.item_name}</h3>
                    {!item.photo && <>
                        <p className="food-description">{item.item_description}</p>
                        {item.dish_new.indexOf("56") !== -1 && <p className="available-category">*Available in Jain</p>}
                    </>}
                    {item.categoryNames && item.categoryNames && <p className="food-cat">In {item.categoryNames}</p>}
                    {isSplCat && item.splcats && item.splcats.length > 0 && <ul className="speciality-list">
                        {item.splcats.map(splCat => <li key={splCat}><img src={getImage(splCat)} alt="" /></li>)}
                    </ul>}
                    {!isDigitalMenu && <p className={hasDiscount ? 'food-price sale-active' : "food-price"}> {formatPrice(item.base_price)}
                        {hasDiscount && <span className="sale-price text-pink">{formatPrice(item.base_price - item.discount)}</span>}

                    </p>}
                </div>
                {!isDigitalMenu && <div className={"food-detail-right"}>
                    {cartCount == 0 && <button className="btn-add-item" onClick={addToCartClickHandler}>Add <span className="fa fa-plus"></span></button>}
                    {cartCount > 0 && <div className="item-counter">
                        <button className="btn-counter minus" onClick={minusClickHandler}><span className="fa fa-minus"></span></button>
                        <button className="btn-counter plus" onClick={addToCartClickHandler}><span className="fa fa-plus"></span></button>
                        <input type="text" value={cartCount} readOnly={true} />
                    </div>}
                    {item.addon_item_exists && <p className="custom-info">Customisable</p>}
                </div>}
                {isDigitalMenu && <div className={"food-detail-right"}>
                    <p className={hasDiscount ? 'food-price sale-active' : "food-price"}>{formatPrice(item.base_price)}
                        {hasDiscount && <span className="sale-price text-pink">{formatPrice(item.base_price - item.discount)}</span>}
                    </p>
                    {item.addon_item_exists && <button className="btn-add-item-2" onClick={addToCartClickHandler}>Customize</button>}
                </div>}
                {item.photo && <div className="food-details-bottom">
                    <p className="food-description">{item.item_description}</p>
                    {item.dish_new.indexOf("56") !== -1 && <p className="available-category">*Available in Jain</p>}
                </div>}
            </div>
            {item.addon_item_exists && addtoCart && <Modal key={item.item_id}>
                <Addons key={item.item_id} item={item} handleClose={handleClose} />
            </Modal>}
        </div>
    )
}


const mapStateToProps = (state, ownProps) => {
    const cartCount = isAddedSelector(state, ownProps.item.item_id);
    const merchant_id =  state.restaurant.details?.merchant_id;
    
    // const splcats = getSpecialCats(state, ownProps.item.item_id);
    //const getItemCategoryItem = splcats.length == 0 ? "" : getItemCategory(state, ownProps.item.item_id);
    return { cartCount,merchant_id }
}

export default connect(mapStateToProps, { cartAddToCart, minusToCart, popPopToggle })(Item)
